import {EnquireNowFormComponent} from '../enquire-now-form/enquire-now-form.component';
import {Component, OnInit} from '@angular/core';
import {ContactService} from '../../service/contact.service';
import {ActivatedRoute} from '@angular/router';
import {LoanDetailsService} from '../../service/loan-details.service';
import {ProfileType} from '../../model/profile-type.model';

@Component({
    selector: 'app-borrower-enquire-now-form',
    templateUrl: './borrower-enquire-now-form.component.html',
    styleUrls: ['../enquire-now-form/enquire-now-form.component.css', './borrower-enquire-now-form.component.css']
})
export class BorrowerEnquireNowFormComponent extends EnquireNowFormComponent implements OnInit {
    salary: string;
    loanAmount: number;
    selectedCity: string;
    cities: any[];
    employeeType: string;

    salaryRange: any = [];

    annualSalaryRange: any = [
        {value: 'Below 5 lakhs per annum'},
        {value: 'Above 5 lakhs per annum'},
    ];

    monthlySalaryRange: any = [
        {value: '< 35K'},
        {value: '35K-50K'},
        {value: '50K-1L'},
        {value: 'Above 1L'}
    ];

    empTypes: any = [
        {value: 'Salaried'},
        {value: 'Self Employed'}
    ];

    constructor(contactService: ContactService, route: ActivatedRoute, private loanService: LoanDetailsService) {
        super(contactService, route);
    }

    async ngOnInit(): Promise<void> {
        this.cities = (await this.loanService.getCitiesWhereLoanIsOffered()).map(c => c.city).sort();
    }

    protected attachParams(metadata: { [p: string]: any } | {}): any {
        super.attachParams(metadata);
        (metadata as any).loanAmount = this.loanAmount;
        this.employeeType === 'Salaried' ? (metadata as any).monthlySalary = this.salary : (metadata as any).annualSalary = this.salary;
        (metadata as any).selectedCity = this.selectedCity;
        (metadata as any).employeeType = this.employeeType;
        (metadata as any).profileType = ProfileType.BORROWER;

        return metadata;
    }

    protected clearAllInputFields(): void {
        super.clearAllInputFields();
        this.salary = '' as any;
        this.loanAmount = '' as any;
        this.employeeType = '' as any;
    }

    changeSalaryInput() {
        if (this.employeeType === 'Salaried') {
            this.salaryRange = this.monthlySalaryRange;
        } else {
            this.salaryRange = this.annualSalaryRange;
        }
    }
}
